import { InputWayTextCharElement } from "common/topic/input_way_text";
import { inputWayTextCharElementSValue } from "components/common/topic/TopicTextChars/TextCharEdit/TextCharEditPayload.logic";

export function getInputWayTextGroupsByLine(
  elements: InputWayTextCharElement[]
): InputWayTextCharElement[][] {
  const res: InputWayTextCharElement[][] = [];
  let currentGroup: InputWayTextCharElement[] = [];
  for (let i = 0; i < elements.length; i++) {
    const el = elements[i];
    const sValue = inputWayTextCharElementSValue(el);
    currentGroup.push(el);
    if (sValue.includes("\n")) {
      res.push(currentGroup);
      currentGroup = [];
    }
  }

  if (currentGroup.length > 0) {
    res.push(currentGroup);
  }

  return res;
}
